export function buildRegister(rows) {
  const workers = new Map();
  for (const row of rows) {
    const timestamp = Date.parse(row.CreatedAt);
    if (!Number.isFinite(timestamp)) continue;
    const day = new Date(timestamp + 330 * 60000).toISOString().slice(0, 10);
    if (!workers.has(row.EmployeeID)) workers.set(row.EmployeeID, { ...row, days: {} });
    const worker = workers.get(row.EmployeeID);
    if (!worker.days[day]) worker.days[day] = { first: row.CreatedAt, count: 0 };
    const entry = worker.days[day];
    entry.count++;
    if (timestamp < Date.parse(entry.first)) entry.first = row.CreatedAt;
  }
  return [...workers.values()].sort((a, b) => String(a.EmployeeName || a.EmployeeID).localeCompare(String(b.EmployeeName || b.EmployeeID)));
}

export function dateColumns(from, to) {
  const result = [];
  for (let day = Date.parse(`${from}T00:00:00Z`); day <= Date.parse(`${to}T00:00:00Z`); day += 86400000) {
    result.push(new Date(day).toISOString().slice(0, 10));
  }
  return result;
}

export function dailyReport(rows) {
  const groups = new Map();
  rows.forEach(row => {
    const stamp = Date.parse(row.CreatedAt);
    if (!Number.isFinite(stamp)) return;
    const day = new Date(stamp + 330 * 60000).toISOString().slice(0, 10);
    const key = `${row.EmployeeID}|${day}`;
    if (!groups.has(key)) groups.set(key, { ...row, key, day, first: row.CreatedAt, last: row.CreatedAt, logins: 0, punches: 0, unknown: 0 });
    const item = groups.get(key);
    item.logins++;
    if (row.Status === 'PUNCHED_IN') item.punches++;
    if (!['PUNCHED_IN', 'ALREADY_IN', 'PUNCHED_OUT', 'ALREADY_OUT', 'PENDING'].includes(row.Status)) item.unknown++;
    if (stamp < Date.parse(item.first)) item.first = row.CreatedAt;
    if (stamp > Date.parse(item.last)) item.last = row.CreatedAt;
  });
  return [...groups.values()].sort((a, b) => b.day.localeCompare(a.day) || String(a.EmployeeName || a.EmployeeID).localeCompare(String(b.EmployeeName || b.EmployeeID)));
}
